import * as d3 from "d3";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { XAxis } from "../chart/XAxis";
import { YAxis } from "../chart/YAxis";


import "./PhoneHeartRate.css";

function PhoneHeartRate({ data, day, mode, selection = [], fill = "#86B2E8" }) {
  const width = 300;
  const height = 90;
  const [marginLeft, marginRight, marginTop, marginBottom] = [21, 15, 15, 0];
  const innerWidth = width - marginLeft - marginRight;
  const innerHeight = height - marginTop - marginBottom;
  var timeKey = mode === "live" ? "timepoint" : "time";
  var timeGap = 10;

  var minDay;
  var maxDay;
  if (mode === "live") {
    minDay = new Date(data[data.length - 1][timeKey]);
    maxDay = new Date(data[data.length - 1][timeKey]);
    minDay.setMinutes(0);
    minDay.setSeconds(0);
    minDay.setMilliseconds(0);
    maxDay.setHours(maxDay.getHours() + 1);
    maxDay.setMinutes(0);
    maxDay.setSeconds(0);
    maxDay.setMilliseconds(0);
    timeGap = 1;
  } else if (mode === "1D") {
    minDay = new Date(day)
    maxDay = new Date(day)
    maxDay.setDate(maxDay.getDate() + 1);
    if (selection.length > 0) {
      timeGap = 1;
      minDay = selection[0];
      maxDay = selection[1];
    }
  }

  const xScale = useMemo(() => {
    return d3
      .scaleTime()
      .domain([minDay, maxDay])
      .range([marginLeft, innerWidth + marginLeft])
      .nice();
  }, [innerWidth, marginLeft, maxDay, minDay]);

  const yScale = useMemo(() => {
    const min = d3.min(data, (d) => d.mean_hr);
    const max = d3.max(data, (d) => d.mean_hr);
    return d3
      .scaleLinear()
      .domain([min, max])
      .range([innerHeight + marginBottom, marginBottom])
      .nice();
  }, [data, innerHeight, marginBottom]);

  const arr = [];
  let current = new Date(day);
  const max = new Date(day);
  max.setDate(max.getDate() + 1);
  while (current <= max) {
    arr.push(new Date(current));
    current.setMinutes(current.getMinutes() + 20);
  }

  const timeKeys = useMemo(() => {
    const filterData = data.filter(x => new Date(x[timeKey]) >= minDay && new Date(x[timeKey]) <= maxDay);
    return filterData.map((x) => x[timeKey]);
  }, [data, maxDay, minDay, timeKey]);

  const filterData = useMemo(() => {
    return data.filter(x => new Date(x[timeKey]) >= minDay && new Date(x[timeKey]) <= maxDay);
  }, [data, maxDay, minDay, timeKey])

  const ranges = useMemo(() => {
    const range = [];
    let lastTime = null;
    if (filterData.length > 0) {
      let firstTime = filterData[0][timeKey];
      filterData.forEach((x) => {
        if (lastTime !== null) {
          const delta = Math.abs(new Date(lastTime) - new Date(x[timeKey]));
          if (delta > 1000 * 60 * timeGap) {
            range.push([firstTime, lastTime]);
            firstTime = x[timeKey];
          }
        }
        lastTime = x[timeKey];
      });
      range.push([firstTime, lastTime])
    }
    return range;
  }, [filterData, timeKey, timeGap]);

  const lines = useMemo(() => {
    if (ranges.length <= 1) {
      return [d3
        .line()
        .x((d) => xScale(new Date(d[timeKey])))
        .y((d) => yScale(d.mean_hr))(filterData)];
    }
    return ranges.map((x) => {
      const index1 = timeKeys.indexOf(x[0]);
      const index2 = timeKeys.indexOf(x[1]);
      var filteredData = filterData.slice(index1, index2 + 1);
      if(filteredData.length === 1) filteredData = filterData.slice(index1, index2 + 2);
      return d3
        .line()
        .x((d) => xScale(new Date(d[timeKey])))
        .y((d) => yScale(d.mean_hr))(filteredData);
    });
  }, [filterData, ranges, timeKey, timeKeys, xScale, yScale]);

  const lineDatas = lines;

  return (
    <>
      {data && (
        <div className="heartRate_chart">
          <div className="heartRate_chart__Chart">
            <svg className="Sparkline heartGraph" viewBox={`0 0 ${width} ${height}`}>
              <g>
                {lineDatas.map((x, index) => (
                  <path
                    style={{ stroke: "#86B2E8", strokeWidth: "1px" }}
                    className="line-chart__line"
                    id={`line-heartrate`}
                    key={index}
                    d={x}
                  />
                ))}
              </g>
              <XAxis xScale={xScale} innerHeight={innerHeight + marginBottom} ticks={10}></XAxis>
              <YAxis yScale={yScale} margin={marginLeft} ticks={4}></YAxis>

            </svg>
          </div>
        </div>
      )}
    </>
  );
}

export default observer(PhoneHeartRate);
